'use client';

import React, { useEffect, useMemo } from 'react';
import { useRouter } from 'next/navigation';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import { TealiumUTag } from 'shared/types/tealium/TealiumUTag';
import OrderConfirmation from '@/components/customercenter-ui/checkout/common/orderConfirmation/orderConfirmation';
import { triggerTealiumEvent, getPageUtagData } from '@/components/customercenter-ui/utils/tealiumUtils';
import { useCheckout } from '@/context/checkoutProvider';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import { routerUrl } from '@/helpers/utils/routerUrl';

const ThankYouTastic = (data: any) => {
  const router = useRouter();
  const { resetContextValues } = useCheckout();
  const order = data?.data?.orderConfirmationData?.dataSource?.order;
  const projectSettings: ProjectSettings = useProjSettings();
  const creditAccount = order?.soaCustomerDetails?.soaCustomer?.Customer?.DivisionCustomers?.[0]?.CreditAccount;

  const extractNumericId = (idString: string): string => {
    return idString.split('-')[0];
  };

  let creditAccountNumber = '';
  if (creditAccount?.creditAccountId) {
    creditAccountNumber = extractNumericId(creditAccount?.creditAccountId || '');
  }

  useEffect(() => {
    resetContextValues?.();
    if (!data?.data?.orderConfirmationData?.dataSource?.order) {
      router.push(routerUrl?.pageNotFound);
    }
  }, []);

  useEffect(() => {
    if (order) {
      const pageUtagData: TealiumUTag = getPageUtagData(
        'Confirmation',
        undefined,
        undefined,
        undefined,
        order,
        undefined,
        undefined,
        projectSettings,
      );
      triggerTealiumEvent(pageUtagData);
    }
  }, [order]);

  const paymentGuardianData = useMemo(() => {
    return {
      benefitsDirect: data?.data?.benefitsDirect,
      customerCare: data?.data?.customerCare,
      paymentGuardianSuccessMessage: data?.data?.paymentGuardianSuccessMessage,
      paymentGuardianErrorMessage: data?.data?.paymentGuardianErrorMessage,
    };
  }, [
    data?.data?.benefitsDirect,
    data?.data?.customerCare,
    data?.data?.paymentGuardianSuccessMessage,
    data?.data?.paymentGuardianErrorMessage,
  ]);

  return (
    <OrderConfirmation
      order={order}
      paymentGuardianData={paymentGuardianData}
      creditAccountNumber={creditAccountNumber}
    />
  );
};

export default ThankYouTastic;
